// extracted by mini-css-extract-plugin
export default {"tabs":"business-tabs_tabs__0KNKH","tab-buttons":"business-tabs_tab-buttons__+603N","active":"business-tabs_active__v3SM1"};